<template>
  <div class="roboticDog">
    <div class="header">
      <img class="img" src="@/assets/robotic/35.png" alt="" />
    </div>
    <div class="daystar">
      <h2 class="title">Lenovo Daystar Bot IS</h2>
      <ul class="list">
        <li class="item">Seamless Mobility</li>
        <li class="item">Safe & User-Centric</li>
        <li class="item">Intelligent Collaboration</li>
        <li class="item">Driving Innovation</li>
      </ul>
      <p class="descOne">
        Unmatched stability and agility for complex terrains and diverse tasks
        with revolutionary six legged design.
      </p>
      <p class="descTwo">
        Equipped with LiDAR and depth cameras, IS perceives, plans, and executes
        with precision.
      </p>
      <p class="descThree">
        Open platform for seamless research and education integration, driving
        creativity and limitless innovation
      </p>
      <img class="imgTwo" src="@/assets/robotic/02.png" alt="" />
      <ul class="daystarParameterTop">
        <li class="item">
          <span class="top">2.5m/s</span>
          <span class="bottom">Max Running Speed</span>
        </li>
        <li class="item">
          <span class="top">50 N.m</span>
          <span class="bottom">Max Joint Torque</span>
        </li>
        <li class="item">
          <span class="top">IP54</span>
          <span class="bottom">Protection Rating</span>
        </li>
      </ul>
      <ul class="daystarParameterBottom">
        <li class="item">
          <div class="topBox">
            <div class="text">
              <span class="top">30 kg</span>
              <span class="bottom">standing</span>
            </div>
            <div class="text">
              <span class="top">10 kg</span>
              <span class="bottom">walking</span>
            </div>
          </div>
          <span class="bottomBox">Max Load Capacity</span>
        </li>
        <li class="item">
          <div class="topBox">
            <div class="text">
              <span class="top">18cm</span>
              <span class="bottom">Max Climbing Height</span>
            </div>
            <div class="text">
              <span class="top">45°</span>
              <span class="bottom">Max Climbing Angle</span>
            </div>
          </div>
          <span class="bottomBox">Maximum Mobility</span>
        </li>
        <li class="item">
          <div class="topBox">
            <div class="text">
              <span class="top">3h</span>
              <span class="bottom">no load</span>
            </div>
            <div class="text">
              <span class="top">2h</span>
              <span class="bottom">10 kg load</span>
            </div>
          </div>
          <span class="bottomBox">Maximum Endurance</span>
        </li>
      </ul>
      <div class="efficient">
        <img src="@/assets/robotic/03.png" alt="" />
      </div>
      <div class="allTerrain">
        <h2 class="headerTitle">All-Terrain, All-Weather Performance</h2>
        <ul class="allTerrainContent">
          <li
            class="allTerrainItem"
            v-for="(item, index) in allTerrainList"
            :key="index"
          >
            <img class="img" :src="item.imgUrl" alt="" />
            <h5 class="title">{{ item.title }}</h5>
            <p class="text">{{ item.text }} {{ item.text2 }}</p>
          </li>
        </ul>
      </div>
      <div class="efficient">
        <img src="@/assets/robotic/10.png" alt="" />
      </div>
      <ul class="spaceFriendly">
        <li
          class="spaceItem"
          v-for="(item, index) in spaceFriendlyList"
          :key="index"
        >
          <div class="left">
            <h2 class="title">
              {{ item.titleOne }} <br />
              {{ item.titleTwo }}
            </h2>
            <div class="itemText">
              <h5 class="smallTitle">{{ item.smallTitleOne }}</h5>
              <p class="text">{{ item.textOne }}</p>
            </div>
            <div class="itemText">
              <h5 class="smallTitle">{{ item.smallTitleTwo }}</h5>
              <p class="text">{{ item.textTwo }}</p>
            </div>
            <div class="itemText">
              <h5 class="smallTitle">{{ item.smallTitleThree }}</h5>
              <p class="text">{{ item.textThree }}</p>
            </div>
          </div>
          <img class="right" :src="item.imgUrl" alt="" />
        </li>
      </ul>
      <div class="rcapp">
        <img class="rcappImg" src="@/assets/robotic/13.png" alt="" />
      </div>
      <div class="versatileBox">
        <h2 class="versatileTitle">
          Versatile Applications for Smart Transformation
        </h2>
        <h5 class="industry">Industry Inspections</h5>
        <div class="powerBox">
          <div class="left">
            <img class="img" src="@/assets/robotic/14.png" alt="" />
          </div>
          <div class="right">
            <img class="img" src="@/assets/robotic/15.png" alt="" />
            <img class="img" src="@/assets/robotic/16.png" alt="" />
            <img class="img" src="@/assets/robotic/17.png" alt="" />
          </div>
        </div>
        <div class="viewBox">
          <div class="left">
            <img class="img" src="@/assets/robotic/18.png" alt="" />
            <img class="img" src="@/assets/robotic/19.png" alt="" />
            <img class="img" src="@/assets/robotic/20.png" alt="" />
            <img class="img" src="@/assets/robotic/21.png" alt="" />
          </div>
          <div class="right">
            <img class="img" src="@/assets/robotic/22.png" alt="" />
          </div>
        </div>
      </div>
      <div class="research">
        <h2 class="researchTitle">Research & Education</h2>
        <div class="researchImgBox">
          <img class="img" src="@/assets/robotic/23.png" alt="" />
          <img class="img" src="@/assets/robotic/24.png" alt="" />
          <img class="img" src="@/assets/robotic/25.png" alt="" />
        </div>
        <div class="researchText">
          <div class="left">
            <h5 class="title">Open SDK</h5>
            <p class="text">Sensor, motor, and drive development</p>
          </div>
          <div class="right">
            <h5 class="title">Development Support</h5>
            <p class="text">
              Includes course materials and custom solutions for research
            </p>
          </div>
        </div>
        <div class="researchText">
          <div class="left">
            <h5 class="title">Applicable Disciplines</h5>
            <p class="text">Mechanical, automation, computer science</p>
          </div>
          <div class="right">
            <h5 class="title">Course Coverage</h5>
            <p class="text">
              From basics to advanced robotics, modeling, and programming
            </p>
          </div>
        </div>
      </div>
      <div class="specifications">
        <h2 class="title">Specifications</h2>
        <img class="img" src="@/assets/robotic/27.png" alt="" />
        <p class="paragraph">
          (1) The technical specifications are based on lab test data. Actual
          performance may vary depending on usage conditions, configuration, and
          environment. Please refer to real-world usage for accurate
          performance. (2) Complete feature list and SDK details are available
          in the development documentation. Some features may require manual
          operation or customization, and performance may vary with different
          configurations. (3) Product appearance and design may change due to
          ongoing optimizations. Please refer to the delivered product for the
          final version. (4) For further technical support or business
          inquiries, please contact our customer service or technical team.
        </p>
      </div>
      <div class="accessories">
        <h2 class="accessoriesTitle">Optional Accessories</h2>
        <div class="accessoriesContent">
          <div class="topImg">
            <img class="img" src="@/assets/robotic/28.png" alt="" />
            <img class="img" src="@/assets/robotic/29.png" alt="" />
          </div>
          <div class="bottomImg">
            <div class="leftImg">
              <img class="img" src="@/assets/robotic/30.png" alt="" />
            </div>
            <div class="rightImg">
              <img class="img" src="@/assets/robotic/31.png" alt="" />
              <img class="imgBottom" src="@/assets/robotic/32.png" alt="" />
            </div>
          </div>
        </div>
        <p class="paragraph">
          (1) Information and specifications for third-party expansion modules
          are provided by external suppliers. Actual performance may vary based
          on module versions, configurations, and environmental factors. Please
          conduct real-world testing for accurate results. (2) Only common
          modules are listed here. For specific configurations or custom
          solutions, our team can assess your needs and recommend suitable
          options. Please consult before use. (3) The appearance of expansion
          modules may change with supplier updates. Final results will reflect
          the delivered version. (4) For more technical support or inquiries,
          contact our customer service or technical team.
        </p>
      </div>
      <div class="footerBox">
        <div class="logoBox">
          <img class="logo" src="@/assets/robotic/33.png" alt="" />
        </div>
        <div class="infoBox">
          <div class="info">
            <p>
              <span class="obvious">Hotline</span>&nbsp;&nbsp;&nbsp;&nbsp; +86
              18116118490
            </p>
            <p>
              <span class="obvious">Website</span>&nbsp;&nbsp;&nbsp;&nbsp;
              daystar.lenovo.com
            </p>
            <p>
              <span class="obvious">Address</span>&nbsp;&nbsp;&nbsp;&nbsp;
              No.696 Songtao Rd, Pudong Dist, Shanghai, China 
            </p>
          </div>
          <img class="qrcode" src="@/assets/robotic/34.png" alt="" />
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
export default {
  data () {
    return {
      allTerrainList: [
        {
          imgUrl: require('@/assets/robotic/04.png'),
          title: 'Step Climbing',
          text: 'Effortlesslynavigating stairs and curbs, up to',
          text2: '18cm'
        },
        {
          imgUrl: require('@/assets/robotic/05.png'),
          title: 'Obstacle Traversal',
          text: 'Handles rugged terrain with ease, crossing obstacles seamlessly'
        },
        {
          imgUrl: require('@/assets/robotic/06.png'),
          title: 'High-Speed & Long Endurance',
          text: 'Speeds up to with a runtime under load, autonomous recharging for continuous operation.'
        },
        {
          imgUrl: require('@/assets/robotic/07.png'),
          title: 'Environment Adaptability',
          text: 'Agile on like dirt, gravel, and grass, ensuring steady movement in any setting.'
        },
        {
          imgUrl: require('@/assets/robotic/08.png'),
          title: 'IP54 Protection Rating',
          text: 'Dustproof, water-resistant,',
          text2: 'for indoor and outdoor use.'
        },
        {
          imgUrl: require('@/assets/robotic/09.png'),
          title: 'Lightweight Design',
          text: 'Compact',
          text2: 'and easy to deploy, quick use in various settings.'
        }
      ],
      spaceFriendlyList: [
        {
          titleOne: 'Space Friendly',
          titleTwo: 'Peace of Mind',
          smallTitleOne: 'Lightweight Design',
          textOne: 'Minimizes impact, safeguarding equipment.',
          smallTitleTwo: 'Silent Movement',
          textTwo: 'Quiet, graceful motion, without disturbance.',
          smallTitleThree: 'Dynamic Obstacle Avoidance',
          textThree:
            'Real-time obstacle detection and precise navigation for worry-free operation.',
          imgUrl: require('@/assets/robotic/11.png')
        },
        {
          titleOne: 'User-Centric',
          titleTwo: 'Seamless Interaction',
          smallTitleOne: 'Gentle Aesthetics',
          textOne: 'Kind, human-like, instantly approachable.',
          smallTitleTwo: 'Real-Time Feedback',
          textTwo:
            'Interactive lighting and dynamic movements for clear, intuitive status updates.',
          smallTitleThree: 'Intuitive Control Interface',
          textThree: 'Simple, one-click operation for easy mastery',
          imgUrl: require('@/assets/robotic/12.png')
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
ul {
  list-style-type: none;
}
.roboticDog {
  padding:0 0 20px 0;
  margin: 0 auto;
  width: 800px;
  text-align: center;
  .header {
    width: 100%;
    margin: 0 auto;
    .img {
      width: 100%;
    }
  }
  .daystar {
    width: 100%;
    .title {
      font-size: 50px;
    }
    .list {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      margin: 20px;
      .item {
        border: 1px solid #505050;
        border-radius: 20px;
        padding: 5px 20px;
        font-size: 15px;
      }
    }
    .descOne {
      font-size: 14px;
      margin: 5px;
      color: #8b8b8b;
    }
    .descTwo {
      font-size: 14px;
      margin: 5px;
      color: #8b8b8b;
    }
    .descThree {
      font-size: 14px;
      margin: 5px;
      color: #8b8b8b;
    }
  }
  .imgTwo {
    margin: 20px 0;
  }
  .daystarParameterTop {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      .top {
        font-size: 25px;
        font-weight: 700;
        line-height: 2;
      }
      .bottom {
        color: #595959;
        font-weight: 700;
      }
    }
  }
  .daystarParameterBottom {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .item {
      .topBox {
        display: flex;
        align-items: center;
        justify-content: center;
        .text {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 10px;

          .top {
            font-size: 25px;
            font-weight: 700;
            line-height: 2;
            margin-right: 10px;
          }
          .bottom {
            font-size: 14px;
            color: #595959;
          }
        }
      }
      .bottomBox {
        color: #595959;
        font-weight: 700;
      }
    }
  }
  .efficient {
    width: 100%;
    margin: 20px 0;
    img {
      width: 100%;
    }
  }
  .allTerrain {
    width: 100%;
    .headerTitle {
      font-size: 30px;
      font-weight: 700;
      text-align: left;
      margin-bottom: 20px;
    }
    .allTerrainContent {
      display: flex;
      align-content: center;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;
      .allTerrainItem {
        width: 49%;
        text-align: left;
        margin-bottom: 15px;
        .img {
          width: 100%;
        }
        .title {
          font-size: 20px;
          font-weight: 700;
          margin: 5px 0;
        }
        .text {
          font-size: 14px;
          color: #595959;
        }
      }
    }
  }
  .spaceFriendly {
    .spaceItem {
      display: flex;
      margin-bottom: 20px;
      .left {
        text-align: left;
        .title {
          font-size: 24px;
        }
        .itemText {
          margin-bottom: 10px;
          .smallTitle {
            font-size: 16px;
          }
          .text {
            font-size: 14px;
            color: #595959;
          }
        }
      }
      .right {
        width: 60%;
      }
    }
  }
  .rcapp {
    width: 100%;
    .rcappImg {
      width: 100%;
    }
  }
  .versatileBox {
    width: 100%;
    text-align: left;
    .versatileTitle {
      font-size: 30px;
      font-weight: 700;
    }
    .industry {
      font-size: 22px;
      margin: 20px 0;
    }
    .powerBox {
      display: flex;
      align-items: center;
      margin: 20px 0;
      .left {
        flex: 1;
        margin-right: 10px;
        height: 345px;
        .img {
          width: 100%;
          height: 345px;
        }
      }
      .right {
        width: 30%;
        .img {
          width: 100%;
          height: 110px;
        }
      }
    }
    .viewBox {
      display: flex;
      .left {
        flex: 1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .img {
          width: 47%;
          height: 100px;
          margin: 0 10px 10px 0;
        }
      }
      .right {
        flex: 1;
        .img {
          width: 100%;
          height: 210px;
        }
      }
    }
  }
  .research {
    width: 100%;
    text-align: left;
    .researchTitle {
      font-size: 26px;
      font-weight: 700;
      margin: 40px 0;
    }
    .researchImgBox {
      display: flex;
      justify-content: space-between;
      .img {
        width: 260px;
        height: 150px;
      }
    }
    .researchText {
      display: flex;
      margin: 20px 0;
      .left {
        margin-right: 10px;
        width: 40%;
        height: 90px;
        background-color: #f4f4f4;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        padding-left: 20px;
        .title {
          font-size: 20px;
          font-weight: 700;
        }
        .text {
          font-size: 14px;
          color: #595959;
        }
      }
      .right {
        flex: 1;
        height: 90px;
        background-color: #f4f4f4;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        padding-left: 20px;
        .title {
          font-size: 20px;
          font-weight: 700;
        }
        .text {
          font-size: 14px;
          color: #595959;
        }
      }
    }
  }
  .specifications {
    text-align: left;
    .title {
      font-size: 26px;
      font-weight: 700;
    }
    .img {
      width: 100%;
    }
    .paragraph {
      font-size: 14px;
      color: #595959;
    }
  }
  .accessories {
    widows: 100%;
    text-align: left;
    margin: 20px 0;
    .accessoriesTitle {
      font-size: 26px;
      font-weight: 700;
    }
    .accessoriesContent {
      .topImg {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-bottom: 20px;
        .img {
          width: 49%;
        }
      }
      .bottomImg {
        display: flex;
        width: 100%;
        justify-content: space-between;
        .leftImg {
          width: 49%;

          .img {
            width: 100%;
            height: 650px;
          }
        }
        .rightImg {
          width: 49%;
          display: flex;
          flex-direction: column;
          .img {
            width: 100%;
            margin-top: -12px;
            height: 390px;
          }
          .imgBottom {
            width: 100%;
            height: 270px;
          }
        }
      }
    }
    .paragraph {
      font-size: 14px;
      color: #595959;
    }
  }
  .footerBox {
    width: 100%;
    .logoBox {
      width: 100%;
      height: 800px;
      display: flex;
      align-items: center;
      justify-content: center;
      .logo {
        width: 405px;
        height: 135px;
      }
    }
    .infoBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info {
        text-align: left;
        .obvious {
          font-weight: 700;
        }
      }
      .qrcode {
        width: 120px;
      }
    }
  }
}
</style>
